import gql from "graphql-tag"
import graph from "@irati/utils/services/graph"

interface WalletBalancesQueryVariables {
  currency: string
  walletType: string
  tenantId: string
}

export const getWalletBalance = (variables: WalletBalancesQueryVariables): any => {
  const query = gql`
    query walletBalance($currency: String!, $walletType: String, $tenantId: String!, $minValue: Int, $maxValue: Int) {
      getWalletBalanceAtTime(currency: $currency, walletType: $walletType, tenantId: $tenantId, minValue: $minValue, maxValue: $maxValue) {
        currency
        value
        walletType
      }
    }
  `
  return graph({query: query.loc.source.body, variables}).then((data: any) => data)
}
